export const ORDER_REPORT_LIST_INITING         = 'ORDER_REPORT_LIST_INITING'

export const ORDER_REPORT_LIST_REQUESTING      = 'ORDER_REPORT_LIST_REQUESTING'
export const ORDER_REPORT_LIST_SUCCESS         = 'ORDER_REPORT_LIST_SUCCESS'
export const ORDER_REPORT_LIST_ERROR           = 'ORDER_REPORT_LIST_ERROR'  

export const ORDER_REPORT_NVKD_REQUESTING      = 'ORDER_REPORT_NVKD_REQUESTING'
export const ORDER_REPORT_NVKD_SUCCESS         = 'ORDER_REPORT_NVKD_SUCCESS'
export const ORDER_REPORT_NVKD_ERROR           = 'ORDER_REPORT_NVKD_ERROR' 

export const ORDER_REPORT_KH_REQUESTING      = 'ORDER_REPORT_KH_REQUESTING'
export const ORDER_REPORT_KH_SUCCESS         = 'ORDER_REPORT_KH_SUCCESS'
export const ORDER_REPORT_KH_ERROR           = 'ORDER_REPORT_KH_ERROR' 

export const ORDER_REPORT_KH_BY_NHOM_REQUESTING      = 'ORDER_REPORT_KH_BY_NHOM_REQUESTING'
export const ORDER_REPORT_KH_BY_NHOM_SUCCESS         = 'ORDER_REPORT_KH_BY_NHOM_SUCCESS'
export const ORDER_REPORT_KH_BY_NHOM_ERROR           = 'ORDER_REPORT_KH_BY_NHOM_ERROR'

export const ORDER_REPORT_KHOXUAT_REQUESTING      = 'ORDER_REPORT_KHOXUAT_REQUESTING'
export const ORDER_REPORT_KHOXUAT_SUCCESS         = 'ORDER_REPORT_KHOXUAT_SUCCESS'
export const ORDER_REPORT_KHOXUAT_ERROR           = 'ORDER_REPORT_KHOXUAT_ERROR' 

export const ORDER_REPORT_NHOMKH_REQUESTING      = 'ORDER_REPORT_NHOMKH_REQUESTING'
export const ORDER_REPORT_NHOMKH_SUCCESS         = 'ORDER_REPORT_NHOMKH_SUCCESS'
export const ORDER_REPORT_NHOMKH_ERROR           = 'ORDER_REPORT_NHOMKH_ERROR' 

export const REPORT_EXPORT_XLS_REQUESTING          = 'REPORT_EXPORT_XLS_REQUESTING'
export const REPORT_EXPORT_XLS_SUCCESS             = 'REPORT_EXPORT_XLS_SUCCESS'
export const REPORT_EXPORT_XLS_ERROR               = 'REPORT_EXPORT_XLS_ERROR'

export const ORDER_REPORT_NVKD_API              = '/api/v1/users/get_list_by_quanly' 
export const ORDER_REPORT_KH_API                = '/api/v1/khachhang/KhachByNvkd'
export const ORDER_REPORT_KHOXUAT_API           = '/api/v1/kho/getKhoAllOfUser'
export const ORDER_REPORT_LIST_API              = '/api/v1/report/baoCaoDonHang'  
export const REPORT_EXPORT_XLS_API              = '/api/v1/report/order_report_export_by_store' 
export const ORDER_REPORT_NHOMKH_API            = '/api/v1/nhomkhachhang/nhomkhachhang_list_actived_by_store'
export const ORDER_REPORT_KH_BY_NHOM_API        = '/api/v1/khachhang/khachhangByNhomOrNvkd'


// WEBPACK FOOTER //
// ./src/views/Reports/OrderReport/constants.js